import { defaultLocale, locales } from './config'

export const getIsoCode = (available: string[], routeName: string): string => {
  if (routeName.includes(defaultLocale)) return locales.find((locale) => locale.code === defaultLocale)!.iso
  const code = available.find((locale) => routeName.includes(locale))
  return locales.find((locale) => locale.code === code)!.iso
}

export const getDefaultLocaleIsoCode = (): string => locales.find((locale) => locale.code === defaultLocale)!.iso
